export default "__VITE_ASSET__7Ov5rLKC__"